

























import Vue from "vue";
import Error from "@/components/basic/Error.vue";
import { DELETE_ERROR } from "@/constants/mutation-types";
import { mapState } from "vuex";

export default Vue.extend({
  name: "CodeField",
  props: {
    name: String,
    value: String,
    length: {
      type: Number,
      default: 6,
    },
    disabled: {
      type: [String, Boolean],
      default: false,
    },
    readonly: {
      type: Boolean,
      default: false,
    },
    handlesError: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      codeArray: Array(this.length).fill(""),

      model: this.value || "",
    };
  },
  mounted() {
    if (this.model) {
      this.codeArray = this.model.split("").slice(0, this.length);
    }
    this.checkIsError();
  },
  methods: {
    onInput(index: number, event: Event) {
      const input = (event.target as HTMLInputElement).value;
      this.codeArray[index] = input.charAt(0);
      this.updateModel();
      if (input.length === 1 && index < this.length - 1) {
        const nextInput = (this.$refs.codeInputs as HTMLInputElement[])[index + 1];
        if (nextInput) {
          nextInput.focus();
        }
      }
    },
    onKeydown(index: number, event: KeyboardEvent) {
      if (event.key === "Backspace" && !this.codeArray[index] && index > 0) {
        this.codeArray[index - 1] = "";
        const previousInput = (this.$refs.codeInputs as HTMLInputElement[])[index - 1];
        if (previousInput) {
          previousInput.focus();
        }
        this.updateModel();
      }
    },

    onPaste(index: number, event: ClipboardEvent) {
      event.preventDefault();

      const clipboardData = event.clipboardData || (window as any).clipboardData;

      if (clipboardData) {
        const pasteData = clipboardData.getData("text");
        const codeToPaste = pasteData.split("").slice(0, this.length);

        codeToPaste.forEach((char: string, idx: number) => {
          if (idx < this.length) {
            this.codeArray[idx] = char;
          }
        });

        this.updateModel();
        this.focusNextInput(index);
      } else {
        console.error("Clipboard data is not available.");
      }
    },

    focusNextInput(index: number) {
      if (index < this.length - 1) {
        //@ts-ignore
        const nextInput = this.$refs.codeInputs[index + 1] as HTMLInputElement | undefined;
        if (nextInput) {
          nextInput.focus();
        }
      }
    },

    updateModel() {
      this.model = this.codeArray.join("");
      this.$emit("input", this.model);
      this.$store.commit(DELETE_ERROR, this.name);
    },
    checkIsError() {
      const checkError = setInterval(() => {
        const error = this.$store.state.errors.get(this.name);
        if (error) {
          clearInterval(checkError);
        }
      }, 50);
    },
  },
  watch: {
    value(newVal: string) {
      this.model = newVal || "";
      this.codeArray = this.model.split("").slice(0, this.length);
    },
    model(newVal: string) {
      this.$emit("input", newVal);
    },
  },
  computed: {
    ...mapState({
      isValidFieldsChanged(): boolean {
        //@ts-ignore
        return this.$store.state.isValidFieldsChanged;
      },
    }),
    hasError() {
      return !!this.$store.state.errors.get(this.name);
    },
  },
  components: {
    Error,
  },
});
